// @ts-nocheck
import useAppDispatch from "@insite/client-framework/Common/Hooks/useAppDispatch";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import {
    convertDateOnlyStringToDate,
    convertDateToDateOnlyString,
} from "@insite/client-framework/Common/Utilities/DateUtilities";
import translate from "@insite/client-framework/Translate";
import DatePicker, { DatePickerState } from "@insite/mobius/DatePicker";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import updateDraftParameter from "@store/Framework/Store/Greif/Pages/OrderHistory/Handlers/UpdateDraftParameter";
import { useOrderHistoryState } from "@store/Framework/Store/Greif/Pages/OrderHistory/OrderHistoryHooks";
import FilterDrawerSection from "@store/Library/Components/FilterDrawerSection";
import { DatePickerPresentationProps } from "@store/MobiusOverrides/DatePicker/DatePicker";
import { filterDrawerProps } from "@store/Themes/common/props/filterDrawer";
import React, { FC } from "react";

export interface OrderHistoryFilterFieldRequestedDeliveryDateRangeProps {}

export interface OrderHistoryFilterFieldRequestedDeliveryDateRangeStyles {
    datePicker?: DatePickerPresentationProps;
    fieldWrapper?: InjectableCss;
}

export const OrderHistoryFilterFieldRequestedDeliveryDateRangeStyles: OrderHistoryFilterFieldRequestedDeliveryDateRangeStyles =
    {
        fieldWrapper: filterDrawerProps.fieldWrapper,
        datePicker: { labelProps: filterDrawerProps.subLabel },
    };

const styles = OrderHistoryFilterFieldRequestedDeliveryDateRangeStyles;

const OrderHistoryFilterFieldRequestedDeliveryDateRange: FC<
    OrderHistoryFilterFieldRequestedDeliveryDateRangeProps
> = () => {
    const dispatch = useAppDispatch();
    const { toDeliveryDate: draftToDeliveryDate, fromDeliveryDate: draftFromDeliveryDate } =
        useOrderHistoryState().draftParameter;

    const fromDateChangeHandler = ({ selectedDay }: Pick<DatePickerState, "selectedDay">) => {
        dispatch(updateDraftParameter({ fromDeliveryDate: convertDateToDateOnlyString(selectedDay) }));
    };

    const toDateChangeHandler = ({ selectedDay }: Pick<DatePickerState, "selectedDay">) => {
        dispatch(updateDraftParameter({ toDeliveryDate: convertDateToDateOnlyString(selectedDay) }));
    };

    const fromDeliveryDate = convertDateOnlyStringToDate(draftFromDeliveryDate);
    const toDeliveryDate = convertDateOnlyStringToDate(draftToDeliveryDate);

    return (
        <FilterDrawerSection title={translate("Requested Delivery Dates")} isAccordion={true}>
            <StyledWrapper {...styles.fieldWrapper} data-test-selector="orderHistory_filterRequestedDeliveryFromDate">
                <DatePicker
                    {...styles.datePicker}
                    label={translate("Requested Delivery Date From")}
                    selectedDay={fromDeliveryDate}
                    onDayChange={fromDateChangeHandler}
                    dateTimePickerProps={{
                        maxDate: toDeliveryDate,
                        ...styles.datePicker?.dateTimePickerProps,
                    }}
                />
            </StyledWrapper>
            <StyledWrapper {...styles.fieldWrapper} data-test-selector="orderHistory_filterRequestedDeliveryToDate">
                <DatePicker
                    {...styles.datePicker}
                    label={translate("Requested Delivery Date To")}
                    selectedDay={toDeliveryDate}
                    onDayChange={toDateChangeHandler}
                    dateTimePickerProps={{
                        minDate: fromDeliveryDate,
                        ...styles.datePicker?.dateTimePickerProps,
                    }}
                />
            </StyledWrapper>
        </FilterDrawerSection>
    );
};

export default OrderHistoryFilterFieldRequestedDeliveryDateRange;
